import { useEffect, useState } from 'react';
import { useAppSelector } from '@/store/hooks';

/**
 * 전역 스피너 오버레이 - spinnerCounter > 0일 때 표시
 */
function Spinner() {
  const spinnerCounter = useAppSelector((s) => s.helpers.spinnerCounter);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (spinnerCounter <= 0) {
      setElapsed(0);
      return;
    }
    const start = Date.now();
    const id = setInterval(() => {
      setElapsed(Math.floor((Date.now() - start) / 1000));
    }, 1000);
    return () => clearInterval(id);
  }, [spinnerCounter > 0]);

  if (spinnerCounter <= 0) return null;

  const bars = 12;

  return (
    <div className="page-spinner-overlay">
      <div className="page-spinner">
        {Array.from({ length: bars }, (_, i) => (
          <div
            key={i}
            className="page-spinner-dot"
            style={{
              transform: `rotate(${i * 30}deg)`,
              animationDelay: `${-((bars - i) / bars) * 1.2}s`,
            }}
          />
        ))}
        <span className="page-spinner-elapsed">{elapsed}s</span>
      </div>
    </div>
  );
}

export default Spinner;
